export const SCHOOL_LEADERBOARDS_KEY = "school-leaderboards";
